import React from 'react';
import { FlexContainer, Loading } from '../../../../components/common';

export const LoadingComponent = () => (
    <FlexContainer grow={1} align='center' justify='center'>
        <Loading loading />
    </FlexContainer>
);